import { gql } from '@apollo/client';

export const GET_LAYOUTS_AND_INSIGHTS_COUNT = gql`
  query GetDashboardLayoutsInsightsCount($input: DashboardLayoutFilterArgs!) {
    data: getDashboardLayoutsOrInsightsCount(input: $input) {
      count
    }
  }
`;
